module.exports = __webpack_public_path__ + "img/product-ketang-jbxl-05.82a65cfd.png";